import createSelector from 'lib/createSelector'
import { isTaxExclusiveForRegion } from 'lib/isTaxExclusive'

export const showTaxExclusivePrices = createSelector(
  (state: App.State) => state.checkout.cart.regionCode || state.geo.currentRegionCode,
  (regionCode): boolean => isTaxExclusiveForRegion(regionCode),
)
